// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"App_wrapper__1NLVZ","title":"App_title__3QYND","input":"App_input__2v6Qj","add":"App_add__L5T5N"};